<template>
  <a-modal
    :title="isAdd ? '新建教室' : '修改教室'"
    :maskClosable="false"
    :width="640"
    :visible="visible"
    :confirmLoading="confirmLoading"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <!-- 教室名字 -->
      <a-form-item label="教室名字" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input
          type="text"
          v-decorator="[
            'placeName',
            {rules: [{ required: true, pattern: /^.{1,12}$/, message: '请输入长度为1~12位的教室名字' }], validateTrigger: 'change'}
          ]"
        />
      </a-form-item>

      <!-- 最大容纳人数 -->
      <a-form-item label="最大容纳人数" :labelCol="{lg: {span: 7}}" :wrapperCol="{lg: {span: 13}}">
        <a-input-number
          :min="1"
          :max="1000"
          style="width: 100%"
          v-decorator="[
            'capacity',
            {rules: [{ required: true, message: '请输入' }]}
          ]"
        />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import classroom from "../../api/classroom";

import school from "../../api/school";

import { analysisAddress } from "../../utils/address";

export default {
  name: "classroomFormModal",
  data() {
    return {
      visible: false,
      confirmLoading: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classroomId: "",
      updateData: {},
      searchSchoolLoading: false, //搜索学校loading
      schoolList: [] //学校list
    };
  },
  methods: {
    //搜索学校
    searchSchool(val = "") {
      this.searchSchoolLoading = true;
      school.searchSchool({ schoolName: val }).then(res => {
        this.searchSchoolLoading = false;
        this.schoolList = res.data;
      });
    },

    //初始化，显示
    init(type, params) {
      this.visible = true;
      this.isAdd = type === "add" ? true : false;

      //初始化form表单数据
      if (params) {
        this.updateData = params;
        let formData = {};
        formData.placeName = params.placeName;
        formData.capacity = params.capacity;
        //记录当前教室的ID
        this.classroomId = params.id;
        setTimeout(() => {
          this.form.setFieldsValue(formData);
        }, 100);
      } else {
        this.form.resetFields();
      }
    },

    //隐藏
    handleCancel() {
      this.visible = false;
      this.$emit("closeForm");
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, value) => {
        console.log("输入的内容是：", value);
        //校验通过
        if (!err) {
          if (this.isAdd) {
            this.addClassroom(value);
          } else {
            this.updateClassroom(value);
          }
        }
      });
    },

    //新增教室
    addClassroom(value) {
      classroom.addClassroom(value).then(res => {
        this.$message.success("新增成功");
        this.handleCancel();
        this.$emit("addClassroom", res.data);
      });
    },

    //修改教室
    updateClassroom(value) {
      classroom.updateClassroom(this.classroomId, value).then(res => {
        this.$message.success("修改成功");
        Object.assign(this.updateData, value);
        this.handleCancel();
      });
    }
  },
  created() {
    //加载初始化码表
    this.searchSchool();
  }
};
</script>
<style lang="scss" scoped>
@import "src/config/var";
</style>